import {BaseDrawer, ICompass}  from './BaseDrawer';
import * as PIXI from 'pixi.js-legacy';

export default class CircleDrawer extends BaseDrawer {

    private bigCircleW = 0;
    private gradCanvasContainer: HTMLElement | null = null; // 业务相关属性移至子类
    constructor(containerRef?: HTMLDivElement, bigCircleW?: number, compassPos?: ICompass, preserveDrawingBuffer?: boolean) {
        super(containerRef, compassPos, true, preserveDrawingBuffer, true);
        if (bigCircleW) {
            this.bigCircleW = bigCircleW;
        }
        if (containerRef) {
            this.drawStaticCircle();
        }
    }

    private getCenterX(baseRadius: number): { x1: number; x2: number } {
        let centerX1 = 0, centerX2 = 0;
        const overlapRatio = 1.01;
        const availableWidth = this.viewportWidth - 2 * baseRadius;
        const overlapLength = 2 * baseRadius * overlapRatio;
        const leftMargin = (availableWidth - overlapLength) * 0.5;
        const rightMargin = (availableWidth - overlapLength) * 0.5;

        centerX1 = this.viewportOffsetX + leftMargin + baseRadius;
        centerX2 = this.viewportOffsetX + this.viewportWidth - rightMargin - baseRadius;
        return { x1: centerX1, x2: centerX2 };
    }

    private drawStaticCircle() {
        if (!this.containerRef) return;
        const baseRadius = this.viewportWidth * 0.15;
        const smallRadius = baseRadius * 0.0667;
        const lineWidth = this.viewportWidth * 0.005;
        const bgLineW = this.viewportWidth * (this.bigCircleW / 400);
        const { x1: centerX1, x2: centerX2 } = this.getCenterX(baseRadius);
        const centerY = this.viewportOffsetY + this.viewportHeight / 2;
        const numCircles = 8;
        const spacing = baseRadius - smallRadius; // 小圆与大圆的间距

        this.drawBigCircle(centerX1, centerY, baseRadius, 0x6EA1EA, lineWidth);
        this.drawBigCircle(centerX2, centerY, baseRadius, 0x6EA1EA, lineWidth);
        this.drawBigCircle(centerX1 + spacing + smallRadius, centerY, bgLineW / 2.2, 0x6EA1EA, lineWidth); //交叉点圆形

        for (let i = 0; i < numCircles; i++) {
            let smallR;
            if (i % 2 === 0) {
                smallR = smallRadius;
            } else {
                smallR = smallRadius * 0.75;
            }

            const angle1 = (i * 2 * Math.PI) / numCircles;
            const x1 = centerX1 + baseRadius * Math.cos(angle1);
            const y1 = centerY + baseRadius * Math.sin(angle1);
            this.drawSmallCircle(x1, y1, smallR, 0xFFFFFF);

            const angle2 = (i * 2 * Math.PI) / numCircles;
            const x2 = centerX2 + baseRadius * Math.cos(angle2);
            const y2 = centerY + baseRadius * Math.sin(angle2);
            this.drawSmallCircle(x2, y2, smallR, 0xFFFFFF);
        }

        const transparentRadius = baseRadius + (bgLineW / 2);
        const { x1: leftX1, x2: leftX2 } = this.getCenterX(transparentRadius);
        this.drawBigCircle(leftX1 + (bgLineW / 2), centerY, baseRadius, 0xFFFFFF, bgLineW, 0.1);
        this.drawBigCircle(leftX2 - (bgLineW / 2), centerY, baseRadius, 0xFFFFFF, bgLineW, 0.1);
        // this.drawBigCircle(leftX1 + (bgLineW / 2), centerY, baseRadius, 0x15181D, bgLineW, 0.5);
        // this.drawBigCircle(leftX2 - (bgLineW / 2), centerY, baseRadius, 0x15181D, bgLineW, 0.5);
    }

    private drawBigCircle(x: number, y: number, radius: number, color: number, lineWidth: number, transparent = 1) {
        if (!this.pixiApp) return;
        const circle = new PIXI.Graphics();
        circle.beginFill(color, 0);
        circle.lineStyle(lineWidth, color, transparent);
        circle.drawCircle(x, y, radius);
        circle.endFill();

        if (circle.geometry) {
            circle.geometry.invalidate();
        }
        this.pixiApp.stage.addChild(circle);
    }

    private drawSmallCircle(x: number, y: number, radius: number, color: number) {
        if (!this.pixiApp) return;
        const circle = new PIXI.Graphics();
        circle.beginFill(color, 1);
        circle.drawCircle(x, y, radius);
        circle.endFill();

        if (circle.geometry) {
            circle.geometry.invalidate();
        }
        this.pixiApp.stage.addChild(circle);
    }

    setTrailPoints(list:any[]){
        this.trailPoints = list;
    }

    public toGradPage(gradCanvasRef: HTMLElement) {
        if (!this.pixiApp) return;
        this.gradCanvasContainer = gradCanvasRef;
        this.useCompass = false;
        this.resizeHandler();
    }

    public toFlyingPage() {
        if (!this.pixiApp) return;
        if (this.gradCanvasContainer) {
            this.gradCanvasContainer.removeChild(this.pixiApp.view);
            this.gradCanvasContainer = null;
        }
        this.lastPoint = { x: 0, y: 0 };
        this.lastYaw = 0;
        this.resetTrail();
        if (this.containerRef) {
            this.containerRef.appendChild(this.pixiApp.view);
        }
        this.useCompass = true;
        this.clearCircles();
        this.resizeHandler();
    }

    // 生命周期方法
    public resizeHandler(isFlytoPage?:boolean) {
        if (this.containerRef) {
            if (this.pixiApp) {
                if(this.gradCanvasContainer){
                    this.initContainer(this.gradCanvasContainer.offsetWidth,this.gradCanvasContainer.offsetHeight);
                }else{
                    this.initContainer();
                }
                const circleDatas = this.circleDatas.map(data => ({
                    pos: { ...data.pos },
                    color: data.color,
                }));
                this.renderResize();
                this.trailGraphics = null
                this.circleNodes = [];
                this.circleDatas = [];
                this.circlesContainer = null;
                 // 重新绘制静态部分
                this.drawStaticCircle();
                if(this.useCompass && !this.gradCanvasContainer){
                    this.drawCompass();
                }
                if(this.gradCanvasContainer){
                    if(this.gradCanvasContainer){
                        this.gradCanvasContainer.appendChild(this.pixiApp!.view);
                    }

                    if(this.trailPoints.length > 0){
                        this.drawTrail();
                    }
                }else{
                    if(this.trailPoints.length > 0){
                        this.drawTrail();
                    }
                }
                circleDatas.forEach(data=>{
                    this.drawCircle(data.pos,data.color);
                })
            }
        }
    }

}
